module.exports = __webpack_public_path__ + "media/images/vp/icon.sharebutton.blue-2c83c7ef1b7d30273e200866075f5d18.svg";